'use client';

import { c as _c } from "react/compiler-runtime";
import { AIFI_DATA_NUMBER_CLASS } from '@/domains/pages/ai-proficiency/typography';
import { formatScore } from '@/utils/format.util';
import { SegmentPillPicker, SEGMENT_PILL_PICKER_CLASS } from '@/domains/pages/shared/segment-pill-picker';
import { computeMedianScore } from '../utils/segment-comparisons';
import { segmentScoreColor } from '../utils/segment-score-color';
import type { SegmentSummary } from '../utils/map-segment-aggregates';
import { cn } from '@/utils/shad';
type SegmentPickerProps = {
  segments: SegmentSummary[];
  selectedName: string;
  onSelect: (name: string) => void;
  className?: string;
};
export function SegmentPicker(t0) {
  const $ = _c(9);
  const {
    segments,
    selectedName,
    onSelect,
    className
  } = t0;
  let t1;
  if ($[0] !== segments) {
    const scored = segments.filter(_temp);
    const median = computeMedianScore(scored.map(_temp2));
    t1 = segments.map(segment_1 => ({
      name: segment_1.name,
      label: segment_1.displayName,
      valueLabel: formatScore(segment_1.score, {
        decimals: 1
      }),
      valueColor: segmentScoreColor(segment_1.score, median),
      valueClassName: AIFI_DATA_NUMBER_CLASS
    }));
    $[0] = segments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const items = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn(SEGMENT_PILL_PICKER_CLASS, className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== items || $[5] !== onSelect || $[6] !== selectedName || $[7] !== t2) {
    t3 = <SegmentPillPicker items={items} selectedName={selectedName} onSelect={onSelect} className={t2} />;
    $[4] = items;
    $[5] = onSelect;
    $[6] = selectedName;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp2(segment_0) {
  return segment_0.score;
}
function _temp(segment) {
  return segment.score != null;
}